/**
 * Utility functions for translating container-related statuses and types
 * Following best practices for reusability across the application
 */

import { CONTAINER_STATUS_LABELS } from '../filters/constants/statusOptions'

/**
 * Translates container status codes to Spanish labels
 * @param status - The status code from the backend
 * @returns Translated status label or original status if not found
 */
export const translateContainerStatus = (status: string): string => {
  return CONTAINER_STATUS_LABELS[status] || status
}

/**
 * Translates cost type codes to Spanish labels
 * @param type - The cost type code from the backend
 * @returns Translated cost type label or original type if not found
 */
export const translateCostType = (type: string): string => {
  const typeLabels: Record<string, string> = {
    SUPPLIER: 'Proveedor',
    OPERATIONAL: 'Operacional',
    INDIRECT: 'Indirecto',
    UNDEFINED: 'No definido',
    UNSPECIFIED: 'No especificado',
  }
  return typeLabels[type] || type
}
